module.exports = __webpack_public_path__ + "img/Болезни коленных суставов.c627c878.jpg";